/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllCoupons } from 'state/coupons/selectors';
import { getAllAddons } from 'state/addons/selectors';

export const getCurrentVisualDeckId = (state) => get(state, ['currentVisualDeck', 'items']);

export const getCurrentVisualDeck = (state) => {
    return get(state, ['currentVisualDeck', 'items'], []);
};

export const requestingCurrentVisualDeck = (state) => get(state, ['currentVisualDeck', 'requesting'], false);

export const errorRequestingCurrentVisualDeck = (state) => get(state, ['currentVisualDeck', 'error'], false);

export const hasScheduledChanges = createSelector(
    getCurrentVisualDeck,
    (currentVisualDeck) => {
        return get(currentVisualDeck, ['has_scheduled_changes'], false);
    },
);
export const getCurrentVisualDeckPlanId = createSelector(
    getCurrentVisualDeck,
    (currentVisualDeck) => {
        return get(currentVisualDeck, ['plan_id'], null);
    },
);